export default "__VITE_ASSET__DDBr$6Jm__"